import {
  CREATE_SPECIALTY_REQUEST,
  UPDATE_SPECIALTY_REQUEST,
  DELETE_SPECIALTY_REQUEST
} from "./types";

export const createSpecialtyRequest = (payload, onSucess) => ({
  type: CREATE_SPECIALTY_REQUEST,
  payload,
  onSucess
});

export const updateSpecialtyRequest = (payload, onSucess) => ({
  type: UPDATE_SPECIALTY_REQUEST,
  payload,
  onSucess
});

export const deleteSpecialtyRequest = (payload, onSucess) => ({
  type: DELETE_SPECIALTY_REQUEST,
  payload,
  onSucess
});
